import { Nullable, EventsSearchObject } from '../../common/types';
import { EventWithId } from '../EventsPageVDE/types';

type EventAttributes = {
  name: string;
  value: string;
}[];

export interface DetailsInterface {
  date: string;
  description: string;
  eventTimestamp: string;
  iconClass: string;
  id: string;
  indicationId: Nullable<string>;
  level: string;
  attributes?: EventAttributes;
}
export interface EventDataInterface {
  color: string;
  description: string;
  icon: string;
  iconClass: string;
  indicationId: string;
  level: string;
  message: string;
  source: string;
  x?: string;
  time?: string;
  type?: string;
  id?: string;
}
export interface TableExplicitColumns {
  columnClass?: string;
  dataFunction: (any) => any;
  headerTitle: string;
  sortable?: string;
  id?: string;
}
export interface EventsTableInterface {
  type: string;
}

export interface CurrentTypedInput {
  id?: string;
  name?: string;
  source?: string;
  description?: string;
}

export interface ExtendedPickerDate {
  end: string | null;
  start: string | null;
}
export interface DatePickerDate {
  end: Date;
  start: Date;
}

export interface LastPreferredEventFilter {
  currentTypedInput: CurrentTypedInput;
  datePickerDate: DatePickerDate;
  filteredEventsByType: FilteredEventsByType[];
}

export enum FilteredEventsByType {
  Emergency = 'EMERGENCY',
  Critical = 'CRITICAL',
  Error = 'ERROR',
  Warning = 'WARNING',
  Info = 'INFO',
  Debug = 'DEBUG',
  ShowAll = 'SHOW ALL',
}
export interface AdditionalInformation {
  'Last 7 days': number;
  'Last 24 hours': number;
}

export interface SelectedEventDetails {
  state?: string;
  operationState?: string;
  'Additional Information': AdditionalInformation;
  date: string;
  iconClass: string;
  id: string;
  indicationId: Nullable<number>;
  level: FilteredEventsByType;
  message: string;
  name: string;
  source: string;
  time?: string | Date;
  device?: string;
  attributes?: EventAttributes;
  description?: string;
}

export interface EventDetailsInitialInterface {
  eventPageDetails: DetailsInterface[] | [];
  vdeEvents: EventWithId[] | [];
  startTime: Date | string | number;
  endTime: Date | string | number;
  isEventDetailsError: boolean;
  errorMessage: string;
  selectedEventDetails: SelectedEventDetails | null;
  lastPreferredEventFilter: Nullable<LastPreferredEventFilter>;
  numberOfResults: number;
  latestOffset: number;
  extendedDates: ExtendedPickerDate;
  maxRowsPerPage: number;
  buttonsDisabledState: Record<EventsButtonType, boolean>;
  filteredEventsByType: any[];
  checkboxTypeError: string | null;
  searchInputValue: EventsSearchObject;
  isContextSelected: boolean;
  latestAppliedFilters: {
    appliedTypes: string[] | [];
    appliedSearchText: EventsSearchObject;
  };
  isLoadingEvents: boolean;
  isLoadingMoreEvents: Record<EventsButtonType, boolean>;
  isLoadingEventDetails: boolean;
  activeVdeRequestId: string | null;
}

export interface EventPageDetailsInterface {
  location: LocationInterface;
}

interface LocationInterface {
  hash: string;
  key: string;
  pathname: string;
  search: string;
  state: StateInterface | undefined;
}

interface StateInterface {
  data: {
    date: { end: Date; start: Date };
    description: string;
    level: string[];
  };
}

export interface SidebarDetailsInterface {
  isStringSidebar?: boolean;
  title?: string;
  isVector: boolean;
}

export enum EventsButtonType {
  Succeeding = 'succeeding',
  Preceding = 'preceding',
  Context = 'fullContext',
}

export interface VdeEvent {
  name: string;
  type: string;
  time: string;
  device: string;
}
